// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"5bf3ba84","732":"a5d350ec","977":"3a8e793c"}[chunkId] + ".chunk.js");